import { Component, Input } from '@angular/core';
import { GeneralLiabilityResponse } from '../../../../../models/api/view/claim/details/general-liability/general-liability-response';
import { BaseComponent } from '../../../../base/base.component';
import { CardComponent } from '../../../../core/panels/card.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { AddressLabelComponent } from '../../../../core/labels/address-label.component';

@Component({
  selector: 'app-occurence-gl',
  imports: [
    DetailPanelComponent,
    DetailItemComponent,
    CardComponent,
    AddressLabelComponent,
  ],
  template: `
    <div class="tw-flex tw-w-full tw-gap-8 tw-py-8">
      <app-card label="Occurrence" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="dataSource?.occurrence">
          <app-detail-item label="Loss description" name="lossDescription" />
          <app-detail-item label="Address" name="address1">
            <ng-template #value let-data>
              <app-address-label
                [street1]="data.address1"
                [street2]="data.address2"
                [city]="data.city"
                [state]="data.state"
                [postalCode]="data.zip"
              />
            </ng-template>
          </app-detail-item>
          <app-detail-item label="Coverage forms" name="coverageForms" />
          <app-detail-item label="Allegations" name="allegations" />
          <app-detail-item
            label="Other responsible parties"
            name="otherResponsibleParties"
          />
        </app-detail-panel>
      </app-card>
      <app-card label="Authority" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="dataSource?.authority">
          <app-detail-item label="Contacted" name="contacted" />
          <app-detail-item label="Report number" name="reportNumber" />
          <app-detail-item label="Report date" name="reportDate" format="d" />
        </app-detail-panel>
      </app-card>
    </div>
  `,
  styles: ``,
})
export class OccurenceGlComponent extends BaseComponent {
  @Input() dataSource: GeneralLiabilityResponse;
}
